import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { hideNativeNavigation, showNativeNavigation } from 'webapp/utils/native-bridge';

export default class MobileGenieRoute extends Route {
	@service('navigation') declare navigationService: Service.Navigation;

	override async beforeModel(): Promise<void> {
		await this.navigationService.initialRequestsPromise;
	}

	override activate(): void {
		hideNativeNavigation();
	}

	override deactivate(): void {
		showNativeNavigation();
	}
}
